import { Context } from "@nuxt/types";

import Api from "@/utils/api";
import debounce from "@/utils/debounce";

interface GetParams {
  ids: string[];
}

export default class ProductsApi extends Api {
  readonly url = "/v2/products/";

  constructor($axios: Context["$axios"]) {
    super("postService", $axios);
  }

  async get({ ids }: GetParams) {
    return await this.request<ManyProductsResponse>({
      method: "GET",
      params: {
        ids,
      },
    });
  }

  @debounce({ timeout: 50, aggregate: true, batch: 10 })
  async getOne(...ids: string[]) {
    return await this.get({ ids });
  }
}
